import { render } from "./BzIcon.vue?vue&type=template&id=0e0e8cea&scoped=true"
import script from "./BzIcon.vue?vue&type=script&lang=js"
export * from "./BzIcon.vue?vue&type=script&lang=js"

import "./BzIcon.vue?vue&type=style&index=0&id=0e0e8cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0e8cea"]])

export default __exports__